export interface IWorkoutTemplateDetail {
    id: string;
    title: string,    
    goal: string,   
    level: string,
    gender: "female" | "male",
    description?: string;
    workout: {
        sets: Array<any>
    },
    
}
export class  WorkoutTemplate{
    id: string = null;
    title: string = null;     
    goal: string = null;   
    gender: "female" | "male" = null;
    workout: {
        sets: any[];
    }
    workouts: any[] = [];
    level: string = null;
    createdBy: string = null;
    creationDate: string = null; 
    
    constructor (init: Partial<WorkoutTemplate>){
        Object.assign(this, init);
    }   

    getTotalSets() {
        if(this.workout?.sets) {
            let toReturn = 0;
            for (const set of this.workout.sets) {
                if(!isNaN(set.sets)) {
                    toReturn += set.sets;
                }
            }
            return toReturn;
        } else return 0;
    }
}